import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d42dccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "口コミ一覧", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "review"
}
const _hoisted_4 = { class: "horizontal" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "内容の確認", -1))
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_n_skeleton = _resolveComponent("n-skeleton")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_Review = _resolveComponent("Review", true)!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_empty = _resolveComponent("n-empty")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    style: {"padding":"10px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout, { style: {"padding":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu),
          _hoisted_1,
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_n_space, {
                key: 0,
                vertical: "",
                style: {"background-color":"white","padding":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "33%"
                  }),
                  _createVNode(_component_n_skeleton, {
                    height: "1rem",
                    width: "66%",
                    sharp: false
                  })
                ]),
                _: 1
              }))
            : (_ctx.reviews.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (r) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: r.id
                    }, [
                      r
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("p", _hoisted_5, _toDisplayString(r.hospitalData.name) + " - " + _toDisplayString(r.nickname), 1)
                            ]),
                            _createElementVNode("p", null, "記入日: " + _toDisplayString(_ctx.getDate(r.createdAtUnix)), 1),
                            (_ctx.changeLoading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " … "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.changeStatus(r.id, 'accepted'))
                                  }, "掲載", 8, _hoisted_8),
                                  _hoisted_9,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.changeStatus(r.id, 'draft'))
                                  }, "差し戻し", 8, _hoisted_10),
                                  _hoisted_11,
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.changeStatus(r.id, 'rejected'))
                                  }, "拒否", 8, _hoisted_12)
                                ])),
                            _createElementVNode("details", null, [
                              _hoisted_13,
                              _createVNode(_component_Review, {
                                reviews: [r]
                              }, null, 8, ["reviews"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_n_divider, { class: "noMargin" })
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_n_empty, { description: "未審査の口コミはありません" })
                ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}